export const THREAD_HEADER_HEIGHT = '96px'
export const BORDER_WIDTH = '1px'
export const PINNED_BANNER_HEIGHT = '40px'
